import React from "react";
import { Configurations } from '../../Utils/Configurations';
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import moment from 'moment';
import './Modal-Codigo-PIX.scss';
import axios from "axios";
import ErrorModal from '../../Components/ErrorModal/ErrorModal';






class ModalCodigoPIX extends React.Component {
    constructor(props) {
        super(props);
        this.Configurations = new Configurations();


        this.copiarCodigo = this.copiarCodigo.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.habilitaEnviarEmail = this.habilitaEnviarEmail.bind(this);
        this.validacaoEmail = this.validacaoEmail.bind(this);
        this.enviarEmail = this.enviarEmail.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.toggleModalCodigoPIX = this.toggleModalCodigoPIX.bind(this);




        this.state = {
            mensagem: '',
            errorMessage: '',
            hasError: false,
            isLoadingEmail: false,
            mensagemEnviadoSucesso: '',
            enviarEmail: false,
            email: ""
        }
    }

    componentWillReceiveProps(newProps) {
        this.setState({ email: newProps.email });
    }



    copiarCodigo(str) {
        const el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        const selected =
            document.getSelection().rangeCount > 0
                ? document.getSelection().getRangeAt(0)
                : false;
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        if (selected) {
            document.getSelection().removeAllRanges();
            document.getSelection().addRange(selected);
        }
        this.setState({ mensagem: "Código copiado com sucesso!" })
    }

    handleInputChange(e) {
        this.setState({ [e.target.name]: e.target.value })
    }

    habilitaEnviarEmail() {
        this.setState({ enviarEmail: true })
    }

    validacaoEmail(inputEmail) {
        const _usuario = inputEmail.substring(0, inputEmail.indexOf("@"));
        const _dominio = inputEmail.substring(inputEmail.indexOf("@") + 1, inputEmail.length);

        if ((_usuario.length >= 1) &&
            (_dominio.length >= 3) &&
            (_usuario.search("@") === -1) &&
            (_dominio.search("@") === -1) &&
            (_usuario.search(" ") === -1) &&
            (_dominio.search(" ") === -1) &&
            (_dominio.search(".") !== -1) &&
            (_dominio.indexOf(".") >= 1) &&
            (_dominio.lastIndexOf(".") < _dominio.length - 1)) {
            return true;
        }
        else return false;
    }

    enviarEmail() {
        this.setState({ isLoadingEmail: true }, () => {
            const body = {
                email: this.state.email,
            }

            let _emailValido = this.state.email.trim() !== '';
            if (_emailValido) {
                _emailValido = this.validacaoEmail(this.state.email)
            }
            axios.post(this.Configurations.apiBasePath + `/pedidos/${this.props.idPedido}/email/pix`, body).then(response => {
                this.setState({ mensagemEnviadoSucesso: "Código PIX enviado com sucesso!" })
            }).catch(this.handleError).finally(() => this.setState({ isLoadingEmail: false }))
        })
    }

    toggleModalCodigoPIX() {
        this.props.toggle();
        this.setState({
            email: '',
            mensagemEnviadoSucesso: '',
            enviarEmail: false,
            mensagem: ''
        })
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response ? err.response.data.message : "Erro inesperado." })
    }

    closeErrorModal() {
        this.setState({ hasError: false, errorMessage: "" })
    }

    render() {
        const {
            isOpen,
            toggle,
            pix
        } = this.props;
        
        return (
            <div className="modal-pix">
                <Modal className="modal-codigo-pix" isOpen={isOpen} toggle={toggle}>
                    <ModalHeader toggle={this.toggleModalCodigoPIX}>Código PIX</ModalHeader>
                    <ModalBody>
                        <div className='row text-center'>
                            <div className='col-12 py-1'>
                                <img src={pix.imagemQrCode} alt="codigo-pix"/>
                            </div>
                        </div>
                        <div className="row text-center">
                            <div className='col-12 py-2'>
                                <p className='m-0'>{pix.txtImagemQrCode}</p>
                            </div>
                        </div>
                        <div className='row text-center py-2'>
                            <div className='col-12 py-1'>
                                <button className='btn btn-outline-info' onClick={() => this.copiarCodigo(pix.txtImagemQrCode)}>Copiar código</button>
                            </div>
                            <div className='col-12 py-2'>
                                {this.state.mensagem && (
                                    <i><p className='m-0 text-info'>{this.state.mensagem}</p></i>
                                )}
                            </div>
                        </div>
                        <div className="row text-center">
                            <div className='col-12'>
                                {!isNaN(pix.valor) && (
                                    <strong>R$ {Number(pix.valor).toFixed(2).replace('.', ',')}</strong>
                                )}
                            </div>
                        </div>
                        <div className='row text-center py-2 mb-3'>
                            <div className='col-12'>
                                <span>Validade:<strong> {moment(pix.dtVencimento).format("DD/MM/YY - LT")}</strong></span>
                            </div>
                        </div>
                        {!this.state.enviarEmail && (
                            <div className='row text-center'>
                                <div className='col-12 ml-1'>
                                    <button className='btn btn-outline-primary' onClick={this.habilitaEnviarEmail}>Enviar por e-mail</button>
                                </div>
                            </div>
                        )}
                        {this.state.enviarEmail && (
                            <div className='row align-items-end py-2'>
                                <div className="col-9">
                                    <label>Email</label>
                                    <input type="email" className="form-control" required id="email" placeholder="" value={this.state.email} name="email" onChange={this.handleInputChange} autoComplete="off" />
                                </div>
                                {this.state.isLoadingEmail ? (
                                    <div className="spinner-border text-primary" role="status" />
                                ) : (
                                    <div className='col-3 text-center'>
                                        <button className="btn btn-outline-success" disabled={!this.validacaoEmail(this.state.email)} onClick={this.enviarEmail}>
                                            enviar</button>
                                    </div>
                                )}
                                <div className='col-12 py-2 text-center'>
                                    {this.state.mensagemEnviadoSucesso && (
                                        <i><p className='m-0 text-success'>{this.state.mensagemEnviadoSucesso}</p></i>
                                    )}
                                </div>
                            </div>
                        )}
                    </ModalBody>
                </Modal>
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />
            </div>
        )
    }
}

export default ModalCodigoPIX;